import { SERVICES_QUERY_KEY } from '../service/queryKeys'

export const LOCATIONS_QUERY_KEY = 'locations'
export const LOCATIONS_BRIEFS_QUERY_KEY = 'locationsBriefs'
export const ARCHIVED_LOCATION_QUERY_KEY = 'archivedLocations'
export const LOCATIONS_WITH_DEFAULT_FOR_BRANCH_QUERY_KEY = 'locationsWithDefaultForBranch'
export const FETCH_LOCATIONS_KEYS = [LOCATIONS_QUERY_KEY, SERVICES_QUERY_KEY]
